/** A3 (UX spec §3.5): collapsible list of the modelling assumptions the
 *  backend actually applied in this run — one line per default site that
 *  fired. Renders nothing when the run used no defaults. */

import type { JSX } from 'react'

export function AssumptionsDisclosure({ assumptions }: { assumptions: string[] }): JSX.Element | null {
  if (assumptions.length === 0) return null
  return (
    <details className="text-xs">
      <summary className="cursor-pointer select-none text-gray-500 hover:text-gray-700">
        Assumptions used in this run ({assumptions.length})
      </summary>
      <ul className="mt-1 ml-5 list-disc space-y-0.5 text-gray-600">
        {assumptions.map((a, i) => (
          <li key={i}>{a}</li>
        ))}
      </ul>
    </details>
  )
}
